import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
    const SectionsArray = [
        <div className="Section-Text">
            <div className="Title">About Me</div>
            <div className="Content">
                I'm a <b>Computer Science</b> student at the <b>University of Waterloo</b>.
                <br/>
                <br/>
                I recently completed an 8-month R&D co-op at <b>Huawei</b> in the <b>HMI Lab</b>, where I worked on <b>LLM</b>-powered applications and explored various ways to integrate large language models into human-machine interaction systems.
                <br/>
                <br/>
                I have a background in <b>Competitive Programming</b> and a strong interest in software development and AI/ML.
            </div>
        </div>
        ,
        <div className="Section-Text">
            <div className="Title">Experience</div>
            <div className="Content">
                <b>Huawei Technologies</b> &mdash; R&D Co-op, HMI Lab
                <br/>
                <span className="Date-Range">Sep 2024 &ndash; Apr 2025 &nbsp;·&nbsp; 8 months</span>
                <br/>
                <br/>
                Worked in the Human-Machine Interaction lab on <b>LLM</b>-powered applications, researching and prototyping integrations of large language models across a range of applied use cases.
            </div>
        </div>
        ,
        <div className="Section-Text">
            <div className="Title">Projects</div>
            <div className="Content">
                This site is currently being redesigned — projects will be showcased here soon.
            </div>
        </div>
        ,
        <div className="Section-Text">
            <div className="Title">Profiles</div>
            <div className="Content">
                <br/>
                Competitive Programming profiles:
                <br/>
                <br/>
                <Link to="https://codeforces.com/profile/RickeyZ"><b>CodeForces</b></Link>
                <br/>
                <Link to="https://leetcode.com/RickeyZheng/"><b>LeetCode</b></Link>
                <br/>
                <Link to="https://dmoj.ca/user/RickeyZ"><b>DMOJ</b></Link>
                <br/>
                <Link to="https://atcoder.jp/users/RickeyZ"><b>AtCoder</b></Link>
                <br/>
                <Link to="https://www.acmicpc.net/user/rickey"><b>Baekjoon</b></Link>
            </div>
        </div>
        ,
        <div className="Section-Text">
            <div className="Title">Resume</div>
            <div className="Content">
                Feel free to reach out via <Link to="https://www.linkedin.com/in/rickey-zheng-03060a242/"><b>LinkedIn</b></Link> or <Link to="mailto:rickey.zhengg@gmail.com"><b>Email</b></Link> to request my resume.
            </div>
        </div>
    ]
    const [SectionIndex, SetSectionIndex] = useState(0);
    const cooldown = useRef(false);

    useEffect(() => {
        const handleWheel = (e) => {
            if (cooldown.current) return;
            cooldown.current = true;
            setTimeout(() => { cooldown.current = false; }, 700);

            if (e.deltaY > 0) {
                SetSectionIndex(prev => Math.min(prev + 1, SectionsArray.length - 1));
            } else {
                SetSectionIndex(prev => Math.max(prev - 1, 0));
            }
        };

        window.addEventListener('wheel', handleWheel);
        return () => window.removeEventListener('wheel', handleWheel);
    }, []);

    return(
        <div className="Home">
            <div className="Left-Side">
                <div className="Intro">
                    Hey, I'm
                </div>
                <div className="My-Name">
                    Rickey Zheng
                </div>
                <div className="Subtitle">
                    CS @ University of Waterloo
                </div>
                <div className="Nav-Text">
                    [
                    <Link onClick={() => SetSectionIndex(0)}>about</Link>
                    /
                    <Link onClick={() => SetSectionIndex(1)}>experience</Link>
                    /
                    <Link onClick={() => SetSectionIndex(2)}>projects</Link>
                    /
                    <Link onClick={() => SetSectionIndex(3)}>profiles</Link>
                    /
                    <Link onClick={() => SetSectionIndex(4)}>resume</Link>
                    ]
                </div>

                <div className="Social-Icons">
                    [
                    <Link to="https://www.linkedin.com/in/rickey-zheng-03060a242/">
                        <FontAwesomeIcon icon={faLinkedin}/>
                    </Link>
                    /
                    <Link to="mailto:rickey.zhengg@gmail.com">
                        <FontAwesomeIcon icon={faEnvelope}/>
                    </Link>
                    /
                    <Link to="https://github.com/RickeyZh">
                        <FontAwesomeIcon icon={faGithub}/>
                    </Link>
                    ]
                </div>
            </div>

            <div className="Diagonal-Line"/>

            {SectionsArray[SectionIndex]}

        </div>
    )
}
